/** Strategy federated canvas layout mode (session-local). */
export type WorkspaceLayoutMode = "parallel" | "sequential";

export const DEFAULT_WORKSPACE_LAYOUT_MODE: WorkspaceLayoutMode = "parallel";

export const WORKSPACE_LAYOUT_MODE_OPTIONS: Array<{
  value: WorkspaceLayoutMode;
  label: string;
}> = [
  { value: "parallel", label: "Parallel" },
  { value: "sequential", label: "Sequential" },
];

export function isWorkspaceLayoutMode(value: unknown): value is WorkspaceLayoutMode {
  return value === "parallel" || value === "sequential";
}
